
document.addEventListener('DOMContentLoaded', (event) => {
    const reviewBlock = document.querySelector('#review_block .okeReviews-reviews-main');
    const reviewBlockWrapper = document.querySelector('#review_block');
    const blurredBlock = document.querySelector('.blurred-block');
    const blurredBlockWrapper = document.querySelector('.reviews-blurred-section');
    const blurredBtn = document.querySelector('.reviews-blurred-btn');
    if(blurredBtn){
        blurredBtn.addEventListener('click', function(){
            blurredBlockWrapper.remove()
        })
    }
    // pop up 
    const popUpButtons = Array.from(document.querySelectorAll('.pop-up-button-js'));
    const shopifySections = Array.from(document.querySelectorAll('.shopify-section'));
    const popUpButtonsWrapper = document.querySelector('.pop-up-buttons__wrapper');
    const accordions = Array.from(document.querySelectorAll('.product__accordion.accordion'))
    const resultsBtn = document.querySelector('.results-trigger');
    const pageContent = document.querySelector('.pop-up-content').innerHTML;
    const popupText = `
    <div class="pdp-selection-popup">
    <button class="close-btn">

        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M390,308l-7.72,7.72-2.63-2.63,7.72-7.72-8.27-8.27,2.8-2.8,8.27,8.27,7.72-7.72,2.63,2.63-7.72,7.72,8.27,8.27-2.8,2.8Z" transform="translate(-379.1 -294.3)"></path></svg>
        <span> Close</span>
    </button>
    <div class="popup-content">
       ${pageContent}
      <div class="popup-content-footer"> 
       <button class="button button-salmon footer-close-btn">Start Shopping</button>
       </div>
    </div>
    
    </div>

`

    
    const pdpInfo = basicLightbox.create(`${popupText}`, {
        closable: true,
        onShow: (instance) => {
           
        },
        onClose: (instance) => {
            document.querySelector('html').classList.remove('lock-scroll');
            shopifySections.map(item => item.classList.add('display-true'));
            accordions.map(item => item.classList.add('display-true'));

            blurredBlock.style.width = `${reviewBlock.offsetWidth}px`;
            blurredBlock.style.height = `${reviewBlock.offsetHeight}px`
            blurredBlockWrapper.style.marginTop = `${ reviewBlockWrapper.offsetHeight - 200 - reviewBlock.offsetHeight }px`
            blurredBlock.style.maxHeight = `${reviewBlock.offsetHeight}px`
        }
        
    });

    const popupTopButton = document.querySelector('.pop-up-top-btn');
  const haveSurprisinglyDifferent = document.querySelector('.have-surprisingly-different');
 
    const openOptions = () => {
        const closeBtn = document.querySelector('.close-btn');
        const footerCloseBtn = document.querySelector('.footer-close-btn')
        if(closeBtn) {            
            closeBtn.addEventListener('click', function(){                         
                pdpInfo.close();
            })
        }  
        if(footerCloseBtn) {
            footerCloseBtn.addEventListener('click', function(){                         
                pdpInfo.close();
            })
        }             
     }
  haveSurprisinglyDifferent.addEventListener("click", () =>{
    pdpInfo.show(openOptions)
    document.querySelector(".reviews-blurred-section").style.display="none"
  })


    if(popupTopButton){
        popupTopButton.addEventListener('click', function(){
            document.querySelector('html').classList.add('lock-scroll')
            pdpInfo.show(openOptions);
            popUpButtonsWrapper.remove()
        })
    }
  
    if(popUpButtons.length){
        popUpButtons.map(btn => {
            btn.addEventListener('click', function(){
                popUpButtonsWrapper.remove()
                shopifySections.map(item => item.classList.add('display-true'));
                accordions.map(item => item.classList.add('display-true'));
                // if(this.classList.contains('pop-up-buttons__button-yes')) {
                //   console.log("Holaaa")
                // document.querySelector('html').classList.add('lock-scroll')
                
                // pdpInfo.show(openOptions);
                // }
                setTimeout(() => {
                    blurredBlock.style.width = `${reviewBlock.offsetWidth}px`;
                    blurredBlock.style.height = `${reviewBlock.offsetHeight}px`
                    blurredBlockWrapper.style.marginTop = `${ reviewBlockWrapper.offsetHeight - 200 - reviewBlock.offsetHeight }px`
                    blurredBlock.style.maxHeight = `${reviewBlock.offsetHeight}px`
                    
                }, 700)
                
            })
        
        })
    }

    const beforeAfterLightbox = basicLightbox.create(`
    <div class="before-after__wrapper">
    <button class="close-btn">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M390,308l-7.72,7.72-2.63-2.63,7.72-7.72-8.27-8.27,2.8-2.8,8.27,8.27,7.72-7.72,2.63,2.63-7.72,7.72,8.27,8.27-2.8,2.8Z" transform="translate(-379.1 -294.3)"></path></svg>
    </button>
            <h2 class="before-after__heading">Before &amp; Afters</h2>
            <div class="before-after__gallery">
                
                    <div class="before-after__image-wrapper">
                        <img src="//cdn.shopify.com/s/files/1/0599/8116/8889/files/1_3283bbc5-6b09-43cc-9ff0-4006ec2ca076_600x.jpg?v=1670889749" alt="">
                    </div>
                
                    <div class="before-after__image-wrapper">
                        <img src="//cdn.shopify.com/s/files/1/0599/8116/8889/files/2_600x.jpg?v=1670889748" alt="">
                    </div>
                
                    <div class="before-after__image-wrapper">
                        <img src="//cdn.shopify.com/s/files/1/0599/8116/8889/files/3_acf3d29d-9169-46e4-a92e-db3cbe3e51b1_600x.jpg?v=1670889748" alt="">
                    </div>
                
                    <div class="before-after__image-wrapper">
                        <img src="//cdn.shopify.com/s/files/1/0599/8116/8889/files/4_600x.jpg?v=1670889748" alt="">
                    </div>
                
            </div>
        </div>
        `, {
            onClose: (instance) => {
                document.querySelector('html').classList.remove('lock-scroll')
            }
        });

        document.querySelector('.before-after-trigger').addEventListener('click', function(){
            document.querySelector('html').classList.add('lock-scroll')
            beforeAfterLightbox.show(() => {
                document.querySelector('.before-after__wrapper .close-btn').addEventListener('click', function(){
                    beforeAfterLightbox.close()
                })
            })
        })



        const resultsLightbox = basicLightbox.create(`
        <div class="results__wrapper">
        <button class="close-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M390,308l-7.72,7.72-2.63-2.63,7.72-7.72-8.27-8.27,2.8-2.8,8.27,8.27,7.72-7.72,2.63,2.63-7.72,7.72,8.27,8.27-2.8,2.8Z" transform="translate(-379.1 -294.3)"></path></svg>
        </button>
 
                    
        While we’re 100% confident that you’ll see amazing results within 30 days, we recognize that seeing is believing. That’s why Unbloat comes with a 30-day money-back guarantee. If you don’t absolutely love the way you look and feel within the first month of using Unbloat, let us know and we’ll issue a refund!
            </div>
            `, {
                onClose: (instance) => {
                    document.querySelector('html').classList.remove('lock-scroll');
              

                }
            });
            if(resultsBtn) {
                resultsBtn.addEventListener('click', function(){
                    document.querySelector('html').classList.add('lock-scroll')
                    resultsLightbox.show(() => {
                        document.querySelector('.results__wrapper .close-btn').addEventListener('click', function(){
                            resultsLightbox.close()
                        })
                    })
                })
            }
          

            document.querySelector('.product__custom-stars a').addEventListener('click', function(){
                shopifySections.map(item => item.classList.add('display-true'));
                accordions.map(item => item.classList.add('display-true'));
                blurredBlock.style.width = `${reviewBlock.offsetWidth}px`;
                blurredBlock.style.height = `${reviewBlock.offsetHeight}px`
                blurredBlockWrapper.style.marginTop = `${ reviewBlockWrapper.offsetHeight - 200 - reviewBlock.offsetHeight }px`
                blurredBlock.style.maxHeight = `${reviewBlock.offsetHeight}px`
            });
})